export default "__VITE_ASSET__DUbM1ilY__"